(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function() {
    var productRecommendationsSection = document.querySelector(".related-products");
    if (productRecommendationsSection === null) return;
    var request = new XMLHttpRequest();
    request.open("GET", productRecommendationsSection.dataset.url);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        productRecommendationsSection.innerHTML =
          container.querySelector(".related-products").innerHTML;
        function waitForSwiperAndInit() {
  if (typeof Swiper !== 'undefined') {
    initRecommendationsSwiper();
  } else {
    setTimeout(waitForSwiperAndInit, 200);
  }
}
waitForSwiperAndInit();

      }
    };
    request.send();
  };

function initRecommendationsSwiper() {
  const sliders = document.querySelectorAll(".ProductS_slid_recom");
  sliders.forEach((slider) => {
    if (slider.swiper) {
      slider.swiper.destroy(true, true);
    }
    new Swiper(slider, {
      direction: "horizontal",
      speed: 1500,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
     breakpoints: {
            150: {
              slidesPerView: 1.4,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 2.8,
              spaceBetween: 20,
            },
            769: {
              slidesPerView: 3.4,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
            1201: {
              slidesPerView: 5,
              spaceBetween: 20,
            },
          },
    });
  });
}
  document.addEventListener("shopify:section:load", function(event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
      loadProductRecommendationsIntoSection();
    }
  });
  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
